import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
const moment = require('moment')

import { INVOICE_STATUSES, INVOICE_SUBSTATUSES } from '../utils'
import Payment from '../components/Payment'
import ThankYou from '../components/ThankYou'
import UploadSlip from '../components/UploadSlip'

import PagePage from '../components/PagePage'
import Error401 from '../components/401'
import Error403 from '../components/403'
import Error500 from '../components/500'
import OrderDetail from '@/components/OrderDetail'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/orders/:id',
      name: 'orders_detail',
      component: OrderDetail,
      meta: {
        requiredLogin: false
      }
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Payment,
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: false,
        focusMode: true,
        // navTitle: 'ชำระเงิน',
        bodyClasses: 'body__wrapper',
        checkInApp: true
      }
    },
    {
      path: '/thank-you',
      name: 'thank_you',
      component: ThankYou,
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: false,
        focusMode: false,
        navTitle: '',
        bodyClasses: 'hide-nav'
      }
    },
    {
      path: '/thank-you/:orderId',
      name: 'thank_you_order',
      component: ThankYou,
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: false,
        focusMode: false,
        navTitle: '',
        bodyClasses: 'hikde-nav'
      }
    },
    {
      path: '/upload-slip/:orderId?',
      name: 'upload-slip',
      component: UploadSlip,
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: false,
        checkInApp: true
      }
    },
    // {
    //   path: '/main-donate',
    //   redirect: '/covid'
    // },
    {
      path: '*',
      name: 'pages',
      component: PagePage
    },
    {
      path: '/401',
      name: 'error401',
      component: Error401
    },
    {
      path: '/403',
      name: 'error403',
      component: Error403
    },
    {
      path: '/500',
      name: 'error500',
      component: Error500
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // TODO: find out why this features is not work
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  router.app.$utils.gaPageView(to.path)
  router.app.$utils.fbTrackPageView()

  if (router.app.$outdated) {
    router.app.$outdated.checkBrowser(to.meta.checkInApp)
  } else {
    setTimeout(() => router.app.$outdated.checkBrowser(to.meta.checkInApp), 1000)
  }

  store.dispatch('initUser')

  if (to.meta.hideCartStatusIcon) {
    store.dispatch('toggleCartStatus', false)
  } else {
    store.dispatch('toggleCartStatus', true)
  }

  if (to.meta.focusMode) {
    store.dispatch('setNavFocusMode', true)
  } else {
    store.dispatch('setNavFocusMode', false)
  }

  if (to.meta.navTitle) {
    store.dispatch('setNavTitle', to.meta.navTitle)
  } else {
    store.dispatch('setNavTitle', '')
  }

  if (to.meta.requiredLogin) {
    if (!store.state.token) {
      next(`/user/login?next=${to.path}`)
    }
  }

  if (to.meta.bodyClasses) {
    router.app.$utils.setBodyClasses(to.meta.bodyClasses)
  } else {
    router.app.$utils.setBodyClasses('')
  }

  store.dispatch('initCart').then(() => {
    console.log('initCart')
    let currentOrderId
    if (to.query && to.query.orderId) {
      currentOrderId = to.query.orderId
    } else if (store.state.publicOrderId) {
      currentOrderId = store.state.publicOrderId
    } else if (store.state.orderId) {
      currentOrderId = store.state.orderId
    }

    if (!to.query.orderId && (!store.state.paymentMethod || store.state.paymentMethod === 'bank_transfer' || !store.state.orderId)) {
      return
    }
    console.log('currentOrderId', currentOrderId)

    if (store.state.orderIdTimestamp) {
      const now = moment()
      const orderTimestamp = moment(store.state.orderIdTimestamp)
      if (now.diff(orderTimestamp, 'hours') > 1) {
        store.dispatch('clearCart').then(() => {
          router.push('/')
        })
        return
      }
    }

    Vue.prototype.$modal.show({
      title: 'กรุณารอสักครู่',
      text: `ระบบกำลังตรวจสอบข้อมูลสถานะของการบริจาค หมายเลข ${currentOrderId}`,
      okButton: false,
      showLoader: true
    })

    // eslint-disable-next-line no-unused-vars
    const gotoCheckoutPage = () => {
      store.dispatch('resetPayment')
      Vue.prototype.$modal.show({
        title: 'ทำรายการไม่สำเร็จ',
        text: 'กรุณาไปหน้าชำระเงินอีกครั้ง',
        okButton: false,
        cancelButtonText: 'ไปหน้าชำระเงิน',
        cancelButton: true,
        cancel: () => {
          if (to.path !== '/checkout') {
            router.push('/checkout')
          }
        }
      })
    }

    if (window.location.search.match(/tmbcancel=t/)) {
      store.dispatch('resetPayment')
      gotoCheckoutPage()
      return
    } else if (window.location.search.match(/tmbsuccess=t/)) {
      Vue.prototype.$modal.hide()
      const paymentMethod = store.state.paymentMethod
      const sku = store.state.cart[0].product.sku
      const cartItems = store.state.cart.map(it => Object.assign({}, it))
      const trackPromise = router.app.$utils.safeTrackPurchase(currentOrderId, router.app.$utils.getCartGrandTotalPrice(), paymentMethod, cartItems)

      Vue.prototype.$modal.show({
        title: '',
        showLoader: true,
        okButton: false
      })

      const publicOrderId = store.state.publicOrderId || currentOrderId
      Promise.all([store.dispatch('clearCart'), trackPromise])
        .then(() => new Promise(resolve => setTimeout(() => resolve(), 1000)))
        .then(() => {
          if (sku !== Vue.config.MAIN_PRODUCT_SKU) {
            // window.document.location = Vue.config.WP_CAMPAIGN_URL.replace(/%sku%/, sku)
            window.document.location = Vue.config.MAIN_WEBSITE_URL + `/thankyou/?orderId=${publicOrderId}`
          } else {
            window.document.location = Vue.config.MAIN_WEBSITE_URL + `/thankyou/?orderId=${publicOrderId}`
          }
        })
      return
    } else {
      gotoCheckoutPage()
      return
    }

    // eslint-disable-next-line no-unreachable
    const startedAt = new Date()
    let recheckInterval = Vue.config.PAYMENT_RECHECK_INTERVAL
    let recheckDelay = 2000

    setTimeout(() => { // we set delay here to softly allow user to read modal before it done.
      let latestSubStatus = INVOICE_SUBSTATUSES.NONE
      console.log('setTimeout')

      let isWorking = false

      const t = setInterval(() => {
        if (isWorking) {
          return
        }
        if (currentOrderId && to.query.orderId || (new Date()) - store.state.orderIdTimestamp > Vue.config.PAYMENT_TIMEOUT || store.state.paymentMethod === 'internet_banking') {
          isWorking = true
          // get order status
          let retrieve = store.state.paymentMethod !== 'thaiqr' && (latestSubStatus === INVOICE_SUBSTATUSES.PAYMENT_TIMEOUT || latestSubStatus === INVOICE_SUBSTATUSES.PAYMENT_PENDING)
          let promise = router.app.$utils.getInvoice(currentOrderId, retrieve)
            .then(invoice => {
              latestSubStatus = invoice.substatus

              if (invoice.status === INVOICE_STATUSES.PAID) {
                clearInterval(t)

                Vue.prototype.$modal.hide()
                const paymentMethod = store.state.paymentMethod
                const sku = store.state.cart[0].product.sku
                const cartItems = store.state.cart.map(it => Object.assign({}, it))

                Vue.prototype.$modal.show({
                  title: '',
                  showLoader: true,
                  okButton: false
                })
                const trackPromise = router.app.$utils.safeTrackPurchase(currentOrderId, router.app.$utils.getCartGrandTotalPrice(), paymentMethod, cartItems)
                const clearPromise = store.dispatch('clearCart')

                const invoicePublicOrderId = invoice.public_order_id || invoice.order_id
                Promise.all([clearPromise, trackPromise])
                  .then(() => new Promise(resolve => setTimeout(() => resolve(), 1000)))
                  .then(() => {
                    if (['bank_transfer', 'cheque'].indexOf(paymentMethod) > -1) {
                      Vue.prototype.$modal.hide()
                      router.push(`/thank-you/${invoicePublicOrderId}`)
                    } else if (sku !== Vue.config.MAIN_PRODUCT_SKU) {
                      // window.document.location = Vue.config.WP_CAMPAIGN_URL.replace(/%sku%/, sku)
                      window.document.location = Vue.config.MAIN_WEBSITE_URL + `/thankyou/?orderId=${invoicePublicOrderId}`
                    } else {
                      window.document.location = Vue.config.MAIN_WEBSITE_URL + `/thankyou/?orderId=${invoicePublicOrderId}`
                    }
                  })
                return
              }

              if (invoice.status === INVOICE_STATUSES.WAIT_FOR_APPROVE && invoice.substatus === INVOICE_SUBSTATUSES.ISSUE_PENDING) {
                clearInterval(t)
                store.dispatch('clearCart')

                Vue.prototype.$modal.show({
                  title: 'มีบางอย่างไม่ถูกต้อง',
                  text: `ระบบพบว่าคุณได้ชำระเงินแล้ว แต่ยังมีบางอย่างไม่ถูกต้อง กรุณาติดต่อผู้ดูแลระบบเพื่อสอบถามข้อมูลเพิ่มเติม<br><br>หมายเลขอ้างอิง: ${invoice.order_id}`,
                  okButtonText: 'ตกลง',
                  ok: () => {
                    router.push('/')
                  }
                })
                return
              }

              if (invoice.substatus === INVOICE_SUBSTATUSES.PAYMENT_TIMEOUT || invoice.substatus === INVOICE_SUBSTATUSES.PAYMENT_PENDING) {
                // Do nothing
              } else if (invoice.substatus === INVOICE_SUBSTATUSES.ERROR) {
                clearInterval(t)
                store.dispatch('resetPayment')

                Vue.prototype.$modal.show({
                  title: 'ทำรายการไม่สำเร็จ',
                  text: 'และระบบยังไม่ได้ทำการตัดเงินของคุณ กรุณาไปหน้าชำระเงินอีกครั้ง ขออภัยในความผิดพลาด',
                  okButtonText: 'ไปหน้าชำระเงิน',
                  ok: () => {
                    if (to !== '/checkout') {
                      router.push('/checkout')
                    }
                  }
                })
              } else if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                clearInterval(t)
                store.dispatch('resetPayment')

                Vue.prototype.$modal.show({
                  title: 'รายการหมดอายุแล้ว',
                  text: 'และระบบยังไม่ได้ทำการตัดเงินของคุณ กรุณาไปหน้าชำระเงินอีกครั้ง ขออภัยในความผิดพลาด',
                  okButtonText: 'ไปหน้าชำระเงิน',
                  ok: () => {
                    if (to !== '/checkout') {
                      router.push('/checkout')
                    }
                  }
                })
              }
            })
            .catch(err => {
              console.log(err)
            })

          promise.then(() => {
            isWorking = false
          })
        }

        if ((new Date()) - startedAt > Vue.config.PAYMENT_RECHECK_TIMEOUT) {
          clearInterval(t)
          store.dispatch('setOrderId', null)
          currentOrderId = null
          delete to.query.orderId
          Vue.prototype.$modal.show({
            title: 'มีบางอย่างผิดพลาด',
            text: 'และระบบยังไม่ได้ทำการตัดเงินของคุณ กรุณาไปหน้าชำระเงินอีกครั้ง ขออภัยในความผิดพลาด',
            okButtonText: 'ไปหน้าชำระเงิน',
            ok: () => {
              if (to !== '/checkout') {
                router.push('/checkout')
              }
            }
          })
        }
      }, recheckInterval)
    }, recheckDelay)
  })

  next()
})

router.afterEach((to, from) => {
  store.dispatch('setPreviousRoute', from)

  if (to.name === 'checkout') {
    store.dispatch('setRouteBeforeCheckout', from)
  }
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js